module.exports = __webpack_public_path__ + "img/mom_r_wide.13a40ad5.svg";